<template lang="pug">
    section#juntos
        div.wrapper
            h2 Juntos, vamos aprender.
            h2 Juntos, vamos superar.

            p
                | A #[strong.fael UniFAEL] sempre lutou pelo desenvolvimento da sociedade e pelo comprometimento com a aprendizagem dos brasileiros.
                | Então, nós não poderíamos deixar de fazer o que está ao nosso alcance pelo bem-estar da população nesses dias difíceis.
            p
                | A prevenção ao #[strong COVID-19] exige medidas urgentes de todos e ficar em casa agora não é apenas um cuidado, é uma
                | atitude de solidariedade com a saúde de todos.
            p.menor
                | E para colaborar com essa medida,
                strong.fael liberamos mais de 100 cursos de diferentes áreas
                | do conhecimento para que você possa aprender
                | sem sair de casa.
            p.menor
                strong Somos pioneiros em Educação a Distância no Brasil
                | e, neste cenário, sabemos da importância de auxiliar cada brasileiro a
                | ter educação de qualidade. Esse é mais um compromisso da #[strong.fael UniFAEL] com a aprendizagem.

            p
                | Juntos, vamos superar.
                br
                | Juntos, vamos aprender.
                br
                | Podem contar conosco.
</template>

<script>
export default {
    name: "section-juntos"
}
</script>

<style lang="stylus" scoped src="./Juntos.styl"></style>
